/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    LambdaClient,
    InvokeCommand,
    InvokeCommandInput,
} from '@aws-sdk/client-lambda';
import { createLambdaPayload } from './httpPayloadBuilder';
import { IFnMappingLambdaOptions } from '../../../interfaces';
import { CallbackFunction } from '../../../types';

const lambdaClient = new LambdaClient({
    region: process.env.AWS_DEFAULT_REGION,
});
export async function invokeLambda(
    functionName: string,
    payload = {},
    options: IFnMappingLambdaOptions = {},
    callback?: CallbackFunction,
): Promise<any> {
    const lambdaParams: InvokeCommandInput = {
        ...options.invocationParams,
        Payload: options.asHttp
            ? createLambdaPayload(payload)
            : JSON.stringify(payload),
        FunctionName: functionName,
    };

    const lambdaResult = await lambdaClient.send(
        new InvokeCommand(lambdaParams),
    );

    const res = {
        Payload: lambdaResult.Payload
            ? Buffer.from(lambdaResult.Payload).toString()
            : undefined,
    };

    return callback ? callback(res) : res;
}
